import React from 'react';
import SystemView from './SystemView';

function Recordings() {
  return <SystemView showSystemFilter={true} />;
}

export default Recordings;
